import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../styles/Sidebar.module.scss';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ContactsBlock from './ContactsBlock';
import NewProductsCarousel from './NewProductsCarousel';
import { getHierarchicalCategories } from '../../utils/categoryTree';

const Sidebar = () => {
  const { list } = useSelector(({ categories }) => categories);
  const { data: contacts } = useSelector((state) => state.contacts);
  const [isCompact, setIsCompact] = useState(false);
  const [catalogOpen, setCatalogOpen] = useState(true);
  const [contactsOpen, setContactsOpen] = useState(false);

  const catalogCategories = useMemo(
    () => getHierarchicalCategories(list, { onlyPublished: true }),
    [list]
  );

  const shouldEnableScroll = catalogCategories.length > 6;

  useEffect(() => {
    const media = window.matchMedia('(max-width: 768px)');

    const updateMode = () => {
      const compact = media.matches;
      setIsCompact(compact);
      setCatalogOpen(true);
      setContactsOpen(false);
    };

    updateMode();
    media.addEventListener('change', updateMode);
    return () => media.removeEventListener('change', updateMode);
  }, []);

  const catalogMenu = (
    <nav>
      <ul className={`${styles.menu} ${shouldEnableScroll ? styles.scrollable : ''}`}>
        {catalogCategories.map(({ id, name, depth }) => (
          <li key={id} className={depth > 0 ? styles.menuItemChild : undefined}>
            <NavLink
              className={({ isActive }) => `${styles.link} ${depth > 0 ? styles.linkChild : ''} ${isActive ? styles.active : ''}`}
              to={`/categories/${id}`}
              style={depth > 0 && !isCompact ? { paddingLeft: `${8 + depth * 14}px` } : undefined}
            >
              {name}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );

  return (
    <section className={`${styles.sidebar}${isCompact ? ` ${styles.sidebarCompact}` : ''}`}>
      <div className={`${styles.sidebarPanel} ${styles.catalogPanel}`}>
        {isCompact ? (
          <button
            type="button"
            className={`${styles.sectionToggle}${catalogOpen ? ` ${styles.sectionToggleOpen}` : ''}`}
            onClick={() => setCatalogOpen((prev) => !prev)}
            aria-expanded={catalogOpen}
          >
            <span className={styles.title}>КАТАЛОГ</span>
            <span className={styles.sectionChevron} aria-hidden="true" />
          </button>
        ) : (
          <div className={styles.title}>КАТАЛОГ</div>
        )}
        <div className={`${styles.sectionBody}${!isCompact || catalogOpen ? ` ${styles.sectionBodyOpen}` : ''}`}>
          {catalogMenu}
        </div>
      </div>

      <div className={`${styles.sidebarPanel} ${styles.novinkiPanel}`}>
        <NewProductsCarousel />
      </div>

      {isCompact ? (
        <div className={`${styles.sidebarPanel} ${styles.contactsPanel}`}>
          <button
            type="button"
            className={`${styles.sectionToggle}${contactsOpen ? ` ${styles.sectionToggleOpen}` : ''}`}
            onClick={() => setContactsOpen((prev) => !prev)}
            aria-expanded={contactsOpen}
          >
            <span className={styles.contactsTitle}>КОНТАКТИ</span>
            <span className={styles.sectionChevron} aria-hidden="true" />
          </button>
          <div className={`${styles.sectionBody}${contactsOpen ? ` ${styles.sectionBodyOpen}` : ''}`}>
            <ContactsBlock contacts={contacts} hideHeader />
          </div>
        </div>
      ) : (
        <ContactsBlock contacts={contacts} />
      )}
    </section>
  );
};

export default Sidebar;
